import Vue from 'vue';
import isMobile from 'ismobilejs';

const themes = {
    'theme-africa': { main: 'africa', mobile: 'africa-mobile' },
};

export function getTheme(state) {
    state = state || Vue.state;

    let serverThemeKey = state.client.get().view.style.theme || 'theme-africa';

    const theme = themes[serverThemeKey];

    if (!theme.main) return { main: theme };

    const allowPortraitTheme = store.get('settings/persistent@allowPortraitTheme');
    if (allowPortraitTheme && theme.portrait) {
        return { main: theme.portrait, fallback: theme.main };
    }

    const allowMobileTheme = store.get('settings/persistent@allowMobileTheme');
    if ((isMobile.phone || isMobile.tablet) && theme.mobile && allowMobileTheme) {
        return { main: theme.mobile, fallback: theme.main };   
    }

    return theme;
}



// WEBPACK FOOTER //
// ./skins/xkiosk/services/theme.service.js